import {
  Divider,
  MenuItem,
  SwipeableDrawer,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import ManageOffer from 'component/BuyerRegistration/ManageOffer';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import DepositManagerPopup from './DepositManager/DepositManagerPopup';
const PrivateOffer = () => {
  return (
    <svg
      version="1.1"
      id="Icons"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 32 32"
      width="28"
      height="28"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.544"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M29,12.6V10c0-0.6-0.4-1-1-1h-6.3c-0.3,0.6-1,1-1.7,1s-1.4-0.4-1.7-1H4c-0.6,0-1,0.4-1,1v2.6c1.2,0.7,2,2,2,3.4
          s-0.8,2.8-2,3.4V22c0,0.6,0.4,1,1,1h14.3c0.3-0.6,1-1,1.7-1s1.4,0.4,1.7,1H28c0.6,0,1-0.4,1-1v-2.6c-1.2-0.7-2-2-2-3.4
          S27.8,13.2,29,12.6z"
        />
        <line
          x1="20"
          y1="13"
          x2="20"
          y2="14"
          stroke="#FFFFFF"
          strokeWidth="0.544"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="20"
          y1="19"
          x2="20"
          y2="18"
          stroke="#FFFFFF"
          strokeWidth="0.544"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="11"
          y1="12"
          x2="11"
          y2="13"
          stroke="#FFFFFF"
          strokeWidth="0.544"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="11"
          y1="19"
          x2="11"
          y2="20"
          stroke="#FFFFFF"
          strokeWidth="0.544"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12,13h-1.5C9.7,13,9,13.7,9,14.5v0c0,0.8,0.7,1.5,1.5,1.5h1c0.8,0,1.5,0.7,1.5,1.5v0c0,0.8-0.7,1.5-1.5,1.5H10"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="0.544"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
      </g>
    </svg>
  );
};

const Invite = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M4.42857 0V5.86207M13.5714 0V5.86207M3.85714 8.7931H7.28571M14.1429 8.7931H10.7143M3.85714 12.3103H7.28571M10.7143 12.3103H14.1429M2.14286 2.93103H15.8571C16.4883 2.93103 17 3.45595 17 4.10345V15.8276C17 16.4751 16.4883 17 15.8571 17H2.14286C1.51168 17 1 16.4751 1 15.8276V4.10345C1 3.45595 1.51167 2.93103 2.14286 2.93103Z"
        stroke="#FFFFFF"
      />
    </svg>
  );
};

const SignContract = ({ color = '#FFFFFF' }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1291 12.6786C11.1291 12.3984 11.3159 12.2115 11.5961 12.2115H17.5742C17.8544 12.2115 18.0412 12.3984 18.0412 12.6786C18.0412 12.9588 17.8544 13.1456 17.5742 13.1456H11.5961C11.3626 13.1456 11.1291 12.9588 11.1291 12.6786ZM11.5961 15.9478H17.5742C17.8544 15.9478 18.0412 15.761 18.0412 15.4808C18.0412 15.2005 17.8544 15.0137 17.5742 15.0137H11.5961C11.3159 15.0137 11.1291 15.2005 11.1291 15.4808C11.1291 15.761 11.3626 15.9478 11.5961 15.9478ZM11.5961 18.7033H15.1456C15.4258 18.7033 15.6126 18.5165 15.6126 18.2363C15.6126 17.956 15.4258 17.7692 15.1456 17.7692H11.5961C11.3159 17.7692 11.1291 17.956 11.1291 18.2363C11.1291 18.4698 11.3626 18.7033 11.5961 18.7033ZM25 15.6676C25 15.9011 24.9066 16.1346 24.7198 16.3214L18.4615 22.4863C18.3681 22.5797 18.2747 22.6264 18.1813 22.6731L15.6593 23.7006C15.5659 23.7473 15.1456 23.8874 14.772 23.5137C14.5385 23.2802 14.445 22.9533 14.5852 22.6264L15.5659 20.1044C15.6126 20.011 15.6593 19.9176 15.7527 19.8242L20.2363 15.3874V9.73626H17.761C17.4808 9.73626 17.294 9.54945 17.294 9.26923V6.93406H9.54121C9.21429 6.93406 8.93407 7.21428 8.93407 7.5412V20.805C8.93407 21.1319 9.21429 21.4121 9.54121 21.4121H12.9973C13.2775 21.4121 13.4643 21.5989 13.4643 21.8791C13.4643 22.1593 13.2775 22.3462 12.9973 22.3462H9.54121C8.70055 22.3462 8 21.6456 8 20.805V7.5412C8 6.70055 8.70055 6 9.54121 6H17.761C17.9478 6 18.0412 6.09341 18.0879 6.14011L21.0302 8.9423C21.1703 9.08241 21.1703 9.26923 21.1703 9.26923V14.4533L22.011 13.6126C22.3846 13.239 22.9451 13.239 23.3187 13.6126L24.7198 15.0137C24.9066 15.2005 25 15.3874 25 15.6676ZM18.228 8.80219H19.5357L19.3022 8.56868L18.228 7.5412V8.80219ZM17.294 22.0192L16.2665 20.9451L15.5659 22.7198L17.294 22.0192ZM24.0659 15.6209L22.6648 14.2665L16.7802 20.1511L18.1346 21.5522L24.0659 15.6209Z"
        fill={color}
      />
    </svg>
  );
};
const RefundIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 1.75C15.3326 1.75 19.25 5.66738 19.25 10.5C19.25 15.3326 15.3326 19.25 10.5 19.25C8.45993 19.253 6.48345 18.5402 4.91489 17.2358L4.70139 17.0529L5.49064 15.3886C6.61762 16.5437 8.10909 17.2739 9.71261 17.4557C11.3161 17.6374 12.9332 17.2595 14.2901 16.386C15.647 15.5124 16.6604 14.1969 17.1588 12.6619C17.6572 11.127 17.6099 9.46708 17.025 7.96303C16.44 6.45897 15.3534 5.20322 13.949 4.40831C12.5445 3.6134 10.9086 3.32817 9.31801 3.60088C7.72743 3.8736 6.27994 4.68752 5.22053 5.90488C4.16112 7.12224 3.55486 8.66825 3.50439 10.2812L3.50001 10.5H5.68751L3.31976 15.5015C2.29532 14.0351 1.74724 12.2888 1.75001 10.5C1.75001 5.66738 5.66739 1.75 10.5 1.75ZM11.375 5.25V7H13.5625V8.75H8.75001C8.64068 8.7498 8.53524 8.79054 8.45445 8.86419C8.37366 8.93785 8.32337 9.03909 8.31349 9.14797C8.30362 9.25685 8.33486 9.36548 8.40108 9.45248C8.46729 9.53947 8.56368 9.59852 8.67126 9.618L8.75001 9.625H12.25C12.8302 9.625 13.3866 9.85547 13.7968 10.2657C14.207 10.6759 14.4375 11.2323 14.4375 11.8125C14.4375 12.3927 14.207 12.9491 13.7968 13.3593C13.3866 13.7695 12.8302 14 12.25 14H11.375V15.75H9.62501V14H7.43751V12.25H12.25C12.3593 12.2502 12.4648 12.2095 12.5456 12.1358C12.6264 12.0621 12.6766 11.9609 12.6865 11.852C12.6964 11.7432 12.6652 11.6345 12.5989 11.5475C12.5327 11.4605 12.4363 11.4015 12.3288 11.382L12.25 11.375H8.75001C8.16985 11.375 7.61345 11.1445 7.20321 10.7343C6.79298 10.3241 6.56251 9.76766 6.56251 9.1875C6.56251 8.60734 6.79298 8.05094 7.20321 7.6407C7.61345 7.23047 8.16985 7 8.75001 7H9.62501V5.25H11.375Z"
        fill="#FFFFFF"
      />
    </svg>
  );
};

export const RequestIcon = ({ color }) => {
  return (
    <svg
      width="21"
      height="29"
      viewBox="0 0 20 19"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_38707_172416)">
        <path
          d="M20.8438 20.2996H19.7656C19.9812 19.5746 20.125 18.8496 20.125 18.1246C20.125 14.4996 17.25 11.5996 13.6562 11.5996C10.0625 11.5996 7.1875 14.4996 7.1875 18.1246C7.1875 18.8496 7.33125 19.5746 7.54688 20.2996H6.46875C6.0375 20.2996 5.75 20.5896 5.75 21.0246C5.75 21.4596 6.0375 21.7496 6.46875 21.7496H14.95H18.6156H20.7719C21.2031 21.7496 21.4906 21.4596 21.4906 21.0246C21.4906 20.5896 21.275 20.2996 20.8438 20.2996ZM8.625 18.1246C8.625 15.2971 10.8531 13.0496 13.6562 13.0496C16.4594 13.0496 18.6875 15.2971 18.6875 18.1246C18.6875 18.8496 18.5437 19.6471 18.1844 20.2996H16.1C16.1 20.2271 16.1 20.1546 16.1 20.0821C16.1 18.9946 15.2375 18.1246 14.1594 18.1246H12.9375C12.65 18.1246 12.4344 17.9071 12.4344 17.6171C12.4344 17.3271 12.65 17.1096 12.9375 17.1096H15.3094C15.7406 17.1096 16.0281 16.8196 16.0281 16.3846C16.0281 15.9496 15.7406 15.6596 15.3094 15.6596H14.375V15.2246C14.375 14.7896 14.0875 14.4996 13.6562 14.4996C13.225 14.4996 12.9375 14.7896 12.9375 15.2246V15.7321C11.9313 15.8046 11.1406 16.6021 11.1406 17.6171C11.1406 18.7046 12.0031 19.5746 13.0813 19.5746H14.3031C14.5906 19.5746 14.8063 19.7921 14.8063 20.0821C14.8063 20.1546 14.8062 20.2271 14.7344 20.2996H9.2C8.76875 19.6471 8.625 18.8496 8.625 18.1246Z"
          fill={color}
        />
        <path
          d="M3.59375 13.0492C4.16875 13.0492 4.74375 12.8317 5.10312 12.3967C5.4625 12.0342 5.67812 11.5992 5.75 11.0917L7.1875 11.4542C7.33125 11.5267 7.54688 11.5267 7.69062 11.5267C8.12187 11.5267 8.48125 11.3817 8.84063 11.1642L13.6562 8.11922L17.0344 10.9467C17.3938 11.2367 17.8969 11.4542 18.4 11.4542C18.5438 11.4542 18.7594 11.4542 18.9031 11.3817L21.0594 10.8017C21.275 10.7292 21.4906 10.5117 21.5625 10.2942C21.6344 10.0767 21.5625 9.78672 21.3469 9.56922L15.3094 3.47922C14.8781 3.11672 14.375 2.89922 13.8 2.89922H5.60625C5.31875 2.02922 4.52813 1.44922 3.59375 1.44922C2.37187 1.44922 1.4375 2.39172 1.4375 3.62422V10.8742C1.4375 12.1067 2.37187 13.0492 3.59375 13.0492ZM14.3031 4.56672L19.4781 9.78672L18.5437 10.0042C18.3281 10.0767 18.1125 10.0042 17.8969 9.85922L14.1594 6.74172C14.0875 6.66922 14.0875 6.66922 14.0156 6.66922C14.0156 6.66922 14.0156 6.66922 13.9437 6.66922C13.8719 6.52422 13.7281 6.52422 13.6562 6.52422H8.625C8.19375 6.52422 7.90625 6.81422 7.90625 7.24922C7.90625 7.68422 8.19375 7.97422 8.625 7.97422H11.1406L8.05 9.93172C7.90625 10.0042 7.69062 10.0767 7.475 10.0042L5.75 9.56922V4.34922H13.8C13.9438 4.34922 14.1594 4.42172 14.3031 4.56672ZM2.875 3.62422C2.875 3.18922 3.1625 2.89922 3.59375 2.89922C4.025 2.89922 4.3125 3.18922 4.3125 3.62422V10.1492V10.8742C4.3125 11.0917 4.24062 11.2367 4.09687 11.3817C3.95312 11.5267 3.80938 11.5992 3.59375 11.5992C3.1625 11.5992 2.875 11.3092 2.875 10.8742V3.62422Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_38707_172416">
          <rect width="21" height="21" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

const Offer = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33233 7.80887L5.33168 7.82033C5.28733 8.5971 5.72244 9.32479 6.44047 9.67366L6.44784 9.67726C6.70098 9.79835 6.90847 9.99798 7.03938 10.2462L7.04232 10.2516C7.40412 10.9405 8.15242 11.3581 8.95015 11.3162L8.96226 11.3156C9.25156 11.2994 9.53874 11.374 9.78354 11.5291C10.459 11.9516 11.3165 11.9516 11.992 11.5291C12.2368 11.374 12.5239 11.2994 12.8133 11.3156L12.8254 11.3162C13.6218 11.3584 14.3711 10.9405 14.7337 10.2505L14.7355 10.2467C14.8669 9.99782 15.0749 9.79786 15.3288 9.67661L15.3347 9.67366C16.0527 9.32463 16.488 8.5971 16.4435 7.82016L16.4428 7.80936C16.4281 7.53576 16.504 7.26495 16.6592 7.03897C17.1057 6.3877 17.1057 5.52894 16.6593 4.87751C16.5044 4.65169 16.4281 4.38104 16.4428 4.10744L16.4435 4.09599C16.488 3.31905 16.0527 2.59152 15.3341 2.24233L15.3275 2.23905C15.0749 2.11829 14.8679 1.91964 14.7368 1.67206L14.733 1.66469C14.3711 0.975788 13.6218 0.558355 12.8254 0.600082L12.8131 0.600736C12.5239 0.616936 12.2368 0.542319 11.9921 0.387192H11.9918C11.3163 -0.0353141 10.4589 -0.0353141 9.78338 0.387192C9.53858 0.542155 9.2514 0.616773 8.96209 0.600573L8.94998 0.599918C8.15341 0.5577 7.40428 0.975625 7.04249 1.66437L7.0397 1.66944C6.90863 1.91816 6.70098 2.11796 6.44751 2.23922L6.44064 2.24249C5.7226 2.59136 5.28733 3.31905 5.33184 4.09599L5.3325 4.10679C5.34722 4.38038 5.2713 4.6512 5.11617 4.87702C4.66961 5.52845 4.66961 6.38737 5.11617 7.03864C5.27113 7.26446 5.34722 7.53527 5.33233 7.80887ZM5.66779 5.25763C5.90718 4.90909 6.02451 4.49117 6.0016 4.06899L6.00095 4.05753C5.97738 3.54274 6.26636 3.06459 6.73289 2.84581L6.73862 2.84303C7.12136 2.65976 7.43472 2.35802 7.63239 1.98264L7.63566 1.97642C7.87604 1.51857 8.37955 1.24104 8.91431 1.26951L8.92609 1.27C9.354 1.29406 9.77863 1.18377 10.1406 0.954352C10.5976 0.668481 11.1776 0.668481 11.6346 0.954352C11.9965 1.18344 12.4212 1.2939 12.8489 1.27017L12.8607 1.26951C13.3981 1.24137 13.8991 1.51857 14.1389 1.97511L14.1433 1.98345C14.341 2.35834 14.654 2.6596 15.0362 2.8427L15.0418 2.84549C15.5157 3.07588 15.8034 3.55157 15.7744 4.0577L15.7737 4.06964C15.7508 4.49182 15.8683 4.90958 16.1077 5.25812C16.397 5.68014 16.3969 6.2365 16.1074 6.65835C15.8682 7.00706 15.7508 7.42498 15.7737 7.84716L15.7744 7.85845C15.8034 8.36458 15.5157 8.84043 15.0416 9.07099L15.0367 9.07328C14.6537 9.25688 14.34 9.55895 14.1421 9.93499L14.1397 9.93989C13.8991 10.3977 13.3964 10.6754 12.8609 10.6468L12.8492 10.6461C12.4213 10.6223 11.9965 10.7327 11.6344 10.962C11.1776 11.2477 10.5976 11.2477 10.1408 10.962C9.81152 10.7533 9.4296 10.6427 9.03982 10.643C9.00202 10.643 8.96406 10.644 8.92609 10.6461L8.91431 10.6466C8.38659 10.6802 7.88734 10.404 7.63517 9.93908L7.63174 9.93269C7.43439 9.55797 7.12152 9.25688 6.73943 9.07377L6.73322 9.07066C6.25916 8.84027 5.97149 8.36441 6.00062 7.85845L6.00127 7.84651C6.02402 7.42433 5.90653 7.0064 5.66729 6.65802C5.37815 6.23601 5.37831 5.67965 5.66779 5.25796V5.25763Z"
        fill="#FFFFFF"
      />
      <path
        d="M12.5512 7.05174C12.5512 7.31841 12.4846 7.56908 12.3512 7.80374C12.2232 8.03841 12.0312 8.23574 11.7752 8.39574C11.5246 8.55574 11.2259 8.65174 10.8792 8.68374V9.33174H10.3592V8.68374C9.85789 8.63574 9.45255 8.47841 9.14322 8.21174C8.83389 7.94508 8.67922 7.59308 8.67922 7.15574H9.65522C9.67122 7.36374 9.73789 7.53708 9.85522 7.67574C9.97255 7.80908 10.1406 7.89441 10.3592 7.93174V6.17174C10.0019 6.08108 9.71122 5.99041 9.48722 5.89974C9.26322 5.80374 9.07122 5.65441 8.91122 5.45174C8.75655 5.24908 8.67922 4.97174 8.67922 4.61974C8.67922 4.17708 8.83389 3.81174 9.14322 3.52374C9.45255 3.23041 9.85789 3.05974 10.3592 3.01174V2.36374H10.8792V3.01174C11.3486 3.05441 11.7246 3.20374 12.0072 3.45974C12.2952 3.71041 12.4579 4.05708 12.4952 4.49974H11.5192C11.5032 4.33441 11.4392 4.18774 11.3272 4.05974C11.2152 3.92641 11.0659 3.83574 10.8792 3.78774V5.51574C11.2366 5.60108 11.5272 5.69174 11.7512 5.78774C11.9752 5.87841 12.1646 6.02508 12.3192 6.22774C12.4739 6.42508 12.5512 6.69974 12.5512 7.05174ZM9.60722 4.57174C9.60722 4.79041 9.67122 4.96108 9.79922 5.08374C9.93255 5.20641 10.1192 5.30508 10.3592 5.37974V3.76374C10.1299 3.79041 9.94589 3.87308 9.80722 4.01174C9.67389 4.15041 9.60722 4.33708 9.60722 4.57174ZM10.8792 7.93174C11.1139 7.89441 11.2979 7.80108 11.4312 7.65174C11.5646 7.49708 11.6312 7.31308 11.6312 7.09974C11.6312 6.88641 11.5646 6.72108 11.4312 6.60374C11.3032 6.48108 11.1192 6.38241 10.8792 6.30774V7.93174Z"
        fill="#FFFFFF"
      />
      <path
        d="M17.9565 13.1953C17.5127 12.4077 16.5286 12.1078 15.7211 12.5139L13.0959 13.7543C12.7334 13.0803 12.0381 12.6512 11.273 12.6296L8.84953 12.5629C8.4658 12.5519 8.08928 12.4545 7.7481 12.2785L7.5015 12.1507C6.23889 11.4925 4.73394 11.4942 3.47263 12.1549L3.48802 11.5963C3.49309 11.4112 3.34729 11.2571 3.16222 11.252L0.50478 11.1788C0.319708 11.1738 0.165727 11.3196 0.160655 11.5046L0.000128454 17.3364C-0.00494426 17.5215 0.140855 17.6757 0.325926 17.6807L2.98336 17.7539H2.99269C3.17416 17.7537 3.32258 17.6092 3.32765 17.4279L3.33518 17.1489L4.02556 16.7793C4.29654 16.6335 4.6135 16.5988 4.90952 16.6825L9.03198 17.8396C9.03918 17.8417 9.04638 17.8434 9.05374 17.845C9.35172 17.9074 9.65543 17.9386 9.95996 17.9385C10.6047 17.9388 11.2419 17.7999 11.8279 17.5308C11.8423 17.5243 11.8562 17.5168 11.8694 17.5083L17.8467 13.6417C17.9958 13.5455 18.0439 13.3496 17.9565 13.1953ZM0.679379 17.0198L0.821414 11.8583L2.80893 11.9129L2.66673 17.0746L0.679379 17.0198ZM11.5258 16.9319C10.7978 17.2605 9.98467 17.3512 9.20216 17.1911L5.09066 16.0373C4.62806 15.9064 4.13258 15.9608 3.70925 16.1884L3.35645 16.3772L3.45103 12.9453C4.56883 12.2017 6.0026 12.1253 7.19321 12.7456L7.43981 12.8734C7.87082 13.096 8.34635 13.2189 8.8312 13.2328L11.2546 13.2996C11.9354 13.319 12.5135 13.8037 12.6516 14.4707L9.0418 14.3714C8.85673 14.3663 8.70275 14.5121 8.69767 14.6972C8.6926 14.8822 8.8384 15.0364 9.02347 15.0415L13.0072 15.1511H13.0167C13.198 15.1509 13.3464 15.0064 13.3515 14.8251C13.3556 14.6795 13.3446 14.5337 13.3191 14.3903L16.0112 13.1181L16.019 13.1143C16.401 12.9209 16.8629 12.9855 17.1769 13.2763L11.5258 16.9319Z"
        fill="#FFFFFF"
      />
      <defs>
        <clipPath id="clip0_25220_146903">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardOff = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.25 10.4361H8.65C7.33768 10.4356 6.05019 10.774 4.9267 11.4145C3.80322 12.055 2.88648 12.9734 2.2756 14.0703C2.25843 13.8667 2.24989 13.6626 2.25 13.4583C2.25 9.2854 5.8316 5.90278 10.25 5.90278V2.125L18.25 8.16944L10.25 14.2139V10.4361Z"
        fill="#FFFFFF"
      />

      <defs>
        <clipPath id="clip0_25220_146922">
          <rect width="18" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardOffGray = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.25 10.4361H8.65C7.33768 10.4356 6.05019 10.774 4.9267 11.4145C3.80322 12.055 2.88648 12.9734 2.2756 14.0703C2.25843 13.8667 2.24989 13.6626 2.25 13.4583C2.25 9.2854 5.8316 5.90278 10.25 5.90278V2.125L18.25 8.16944L10.25 14.2139V10.4361Z"
        fill="#C5C5C5"
      />
      <defs>
        <clipPath id="clip0_25220_146961">
          <rect width="18" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const Reply = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25339_206519)">
        <path
          d="M7.75 10.4361H9.35C10.6623 10.4356 11.9498 10.774 13.0733 11.4145C14.1968 12.055 15.1135 12.9734 15.7244 14.0703C15.7416 13.8667 15.7501 13.6626 15.75 13.4583C15.75 9.2854 12.1684 5.90278 7.75 5.90278V2.125L-0.25 8.16944L7.75 14.2139V10.4361Z"
          fill="#FFFFFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_25339_206519">
          <rect
            width="18"
            height="17"
            fill="white"
            transform="matrix(-1 0 0 1 18 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const NeedHelp = () => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25220_146967)">
        <path
          d="M12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875Z"
          stroke="#EEAD06"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 17.7085V17.7189"
          stroke="#EEAD06"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5013 14.0627C12.4821 13.7246 12.5733 13.3893 12.7612 13.1075C12.9491 12.8257 13.2235 12.6126 13.543 12.5002C13.9345 12.3505 14.2859 12.1119 14.5696 11.8033C14.8533 11.4947 15.0614 11.1244 15.1777 10.7217C15.2939 10.3189 15.3151 9.89468 15.2396 9.48236C15.164 9.07004 14.9938 8.68089 14.7423 8.34554C14.4907 8.01019 14.1648 7.7378 13.7901 7.54982C13.4155 7.36183 13.0023 7.26338 12.5831 7.26222C12.1639 7.26105 11.7502 7.35721 11.3745 7.54312C10.9988 7.72902 10.6713 7.9996 10.418 8.33355"
          stroke="#EEAD06"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25220_146967">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const Timer = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.51496 1.01896C8.34401 1.00635 8.17225 1 8 1V0C8.19685 0 8.39314 0.00726199 8.58852 0.0216722L8.51496 1.01896ZM10.5193 1.46905C10.1985 1.34533 9.86912 1.2454 9.53371 1.17008L9.75282 0.194382C10.1361 0.280463 10.5126 0.394665 10.8792 0.536055L10.5193 1.46905ZM11.889 2.17971C11.7458 2.08402 11.5994 1.99388 11.4503 1.90939L11.9432 1.0393C12.1136 1.13586 12.2809 1.23888 12.4446 1.34824C12.6082 1.4576 12.7674 1.5727 12.9219 1.69322L12.3066 2.48158C12.1715 2.37612 12.0322 2.27541 11.889 2.17971ZM13.7231 3.96934C13.5252 3.68829 13.3068 3.42218 13.0697 3.17321L13.794 2.48368C14.0649 2.76821 14.3145 3.07233 14.5407 3.39353L13.7231 3.96934ZM14.4672 5.32122C14.4012 5.16208 14.3296 5.00583 14.2526 4.85271L15.1458 4.40311C15.2339 4.5781 15.3157 4.75667 15.391 4.93853C15.4664 5.12039 15.5348 5.30453 15.5962 5.49054L14.6467 5.80423C14.5929 5.64147 14.5331 5.48035 14.4672 5.32122ZM14.9979 7.82822C14.9895 7.48455 14.9557 7.14197 14.8969 6.80326L15.8822 6.63231C15.9494 7.01939 15.988 7.41092 15.9976 7.80367L14.9979 7.82822ZM14.8655 9.36563C14.8991 9.1967 14.9264 9.02699 14.9474 8.85687L15.9398 8.97929C15.9159 9.17372 15.8847 9.36766 15.8463 9.56072C15.8079 9.75378 15.7625 9.94489 15.7102 10.1337L14.7464 9.867C14.7922 9.70179 14.8319 9.53457 14.8655 9.36563ZM13.914 11.745C14.0979 11.4546 14.2602 11.151 14.3995 10.8367L15.3137 11.2419C15.1545 11.6011 14.969 11.9481 14.7588 12.28L13.914 11.745ZM12.9497 12.9497C13.0715 12.828 13.1885 12.702 13.3005 12.5722L14.0577 13.2254C13.9297 13.3737 13.796 13.5177 13.6569 13.6569L12.9497 12.9497Z"
        fill="#F93939"
      />
      <path
        d="M8 1C6.84885 1 5.71545 1.2839 4.70022 1.82655C3.68499 2.3692 2.81926 3.15386 2.17971 4.11101C1.54017 5.06816 1.14654 6.16827 1.03371 7.31388C0.920876 8.45949 1.09232 9.61525 1.53285 10.6788C1.97337 11.7423 2.66939 12.6808 3.55925 13.4111C4.44911 14.1414 5.50533 14.6409 6.63437 14.8655C7.76341 15.0901 8.93041 15.0327 10.032 14.6986C11.1336 14.3644 12.1358 13.7637 12.9497 12.9497L13.6569 13.6569C12.7266 14.5871 11.5812 15.2736 10.3223 15.6555C9.06332 16.0374 7.72961 16.1029 6.43928 15.8463C5.14895 15.5896 3.94183 15.0187 2.92486 14.1841C1.90788 13.3495 1.11243 12.2769 0.608966 11.0615C0.105504 9.846 -0.0904279 8.52514 0.0385242 7.21586C0.167476 5.90659 0.617333 4.64933 1.34825 3.55544C2.07916 2.46155 3.06857 1.5648 4.22883 0.94463C5.38909 0.324457 6.68439 0 8 0V1Z"
        fill="#F93939"
      />
      <path
        d="M7.5 3C7.77614 3 8 3.22386 8 3.5V8.70984L11.2481 10.5659C11.4878 10.7029 11.5711 11.0083 11.4341 11.2481C11.2971 11.4878 10.9917 11.5711 10.7519 11.4341L7.25193 9.43412C7.09615 9.3451 7 9.17943 7 9V3.5C7 3.22386 7.22386 3 7.5 3Z"
        fill="#F93939"
      />
    </svg>
  );
};
const CloseIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z"
          fill="#FFFFFF"
        ></path>{' '}
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
          fill="#FFFFFF"
        ></path>{' '}
      </g>
    </svg>
  );
};

const ViewAllOff = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <g clip-path="url(#clip0_25447_51386)"> */}
      <path
        d="M9.16602 5H16.666"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.16602 10H16.666"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 15H16.6667"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33398 13.3327C3.33398 12.8907 3.50958 12.4667 3.82214 12.1542C4.1347 11.8416 4.55862 11.666 5.00065 11.666C5.44268 11.666 5.8666 11.8416 6.17916 12.1542C6.49172 12.4667 6.66732 12.8907 6.66732 13.3327C6.66732 13.8252 6.25065 14.166 5.83398 14.5827L3.33398 16.666H6.66732"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.00065 8.33398V3.33398L3.33398 5.00065"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      {/* </g> */}
      {/* <defs>
        <clipPath id="clip0_25447_51386">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs> */}
    </svg>
  );
};
const DiscusAgent = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9182 1.71376C11.0141 1.41437 10.0298 1.25 9 1.25C4.58172 1.25 1 4.27594 1 8.00862C1 9.46604 1.54603 10.8157 2.4747 11.9196L1.5 16.5L5.41607 14.0527C6.49418 14.5099 7.71152 14.7672 9 14.7672C13.4183 14.7672 17 11.7413 17 8.00862C17 7.32386 16.8795 6.66288 16.6553 6.04001"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 1V5"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 3H13"
        stroke="#FFFFFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const VendorActionDrawer = ({
  setViewPrivateOffer,
  acceptLog,
  Glass,
  discussAgent,
  userType,
  setOpenCommenceStageTwo,
  isWinner,
  stagetwo,
  setOpen,
  profileDetails,
  open,
  setActionDrawerOpen,
  data,
  manageOfferClick,
  getListInfo,
  vendorDatas,
  setManageOffer,
  setOpenhistorydialog,
  buyerRegisterTableData,
  manageOffer,
  manageOfferClickClose,
  openhistorydialog,
  offerStatusdata,
  handleClosee,
  vendorofferStatus,
  vendorofferUniqueId,
  replyToVendorFunc,
  setForwardCountertobuyer,
  setAcceptanceCertificate,
  handleOpen,
  stage,
  handleCommenceESign,
  handleOpenFinalContractDialog,
  setVendorGeneratePdf,
  handleOpenView,
  isEsignRequested,
  hasVendorContract,
  ownerFullName,
}) => {
  const theme = useTheme();
  const history = useHistory();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const [openDepositManager, setOpenDepositManager] = useState(false);
  const handleOpendeposit = () => {
    setOpenDepositManager(true);
    setActionDrawerOpen((prev) => !prev);
  };
  const handleClosedeposit = () => {
    setOpenDepositManager(false);
    setOpen(false);
  };

  return (
    <SwipeableDrawer
      open={open}
      anchor="bottom"
      onClose={() => {
        setActionDrawerOpen((prev) => !prev);
      }}
      PaperProps={{
        sx: {
          backgroundColor: '#3C3C3C',
          borderRadius: '8px 8px 0 0',
          maxHeight: 'auto',
          overflowY: 'auto',
        },
      }}
      style={{ zIndex: '100000' }}
    >
      {userType != 'Vendor' ? (
        <>
          <MenuItem
            disableTouchRipple
            value={20}
            sx={{ minHeight: matchessm ? '0px' : '' }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 400,
                fontSize: '12px',
                color: '#8E8A8A',
                lineHeight: 'normal',
                fontStyle: 'normal',
              }}
            >
              - Action for {ownerFullName} -
            </Typography>
          </MenuItem>
          <MenuItem
            value={20}
            sx={{ minHeight: matchessm ? '0px' : '' }}
            disabled
            onClick={() => {
              setActionDrawerOpen((prev) => !prev);
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <Invite /> Meeting Invite
            </Typography>
          </MenuItem>
          <Divider />

          <MenuItem
            value={20}
            sx={{ minHeight: matchessm ? '0px' : '' }}
            // disabled={!data?.price}
            disabled={
              !data?.price ||
              data?.status == 'Private Offer' ||
              data?.buyerId == 0
            }
            onClick={() => {
              setActionDrawerOpen((prev) => !prev);
              manageOfferClick();
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <Offer /> Manage Offer
            </Typography>
          </MenuItem>
          {(manageOffer || openhistorydialog) && (
            <ManageOffer
              open={manageOffer}
              onClose={manageOfferClickClose}
              offerStatusdata={offerStatusdata}
              buyerId={data?.buyerId}
              offerUniqueIds={data?.offerUniqueId}
              getListInfo={getListInfo}
              row={data}
              vendorDatas={vendorDatas}
              moxouserId={true}
              setManageOffer={setManageOffer}
              setOpenhistorydialog={setOpenhistorydialog}
              tableData={buyerRegisterTableData}
              setVendorGeneratePdf={setVendorGeneratePdf}
            />
          )}

          <MenuItem
            value={20}
            sx={{ minHeight: matchessm ? '0px' : '' }}
            disabled={!data?.price}
            onClick={() => {
              setActionDrawerOpen((prev) => !prev);
              handleClosee();
              replyToVendorFunc(vendorofferUniqueId, vendorofferStatus);
              // setForwardtovendor(!forwardtovendor);
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <Reply /> Reply to Vendor
            </Typography>
          </MenuItem>
          <MenuItem
            value={20}
            sx={{ minHeight: matchessm ? '0px' : '' }}
            disabled={
              !data?.price ||
              vendorofferStatus != 'Counter Offer' ||
              stage == 'ST2' ||
              (vendorofferStatus == 'Counter Offer' &&
                data?.statusBuyer == 'Buyer Notified')
            }
            onClick={() => {
              setActionDrawerOpen((prev) => !prev);
              handleClosee();
              setForwardCountertobuyer(true);
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <ForwardOff /> Forward Counter Offer
            </Typography>
          </MenuItem>
          <MenuItem
            value={20}
            sx={{ minHeight: matchessm ? '0px' : '' }}
            disabled={
              !data?.price ||
              (vendorofferStatus == 'Rejected' &&
                data?.statusBuyer != 'Buyer Notified') ||
              !(
                vendorofferStatus == 'Counter Offer' ||
                vendorofferStatus == 'Accepted'
              )
            }
            onClick={() => {
              setActionDrawerOpen((prev) => !prev);
              setAcceptanceCertificate(true);
              setOpen(false);
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <ForwardOff /> Acceptance Certificates
            </Typography>
          </MenuItem>
          <MenuItem
            value={20}
            sx={{ minHeight: matchessm ? '0px' : '' }}
            disabled={
              profileDetails?.PropertyDetails?.property?.status == 'Unpublish'
            }
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
              onClick={() => {
                handleOpen();
                setActionDrawerOpen((prev) => !prev);
              }}
            >
              <Offer />
              Manage Private Offer
            </Typography>
          </MenuItem>
          <MenuItem
            value={20}
            sx={{ minHeight: matchessm ? '0px' : '' }}
            onClick={handleOpendeposit}
            disabled={
              profileDetails?.PropertyDetails?.property?.status == 'Unpublish'
            }
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <RequestIcon color={'#ffff'} /> Deposit Manager
            </Typography>
          </MenuItem>
          {openDepositManager && (
            <DepositManagerPopup
              openDepositManager={openDepositManager}
              handleClosedeposit={handleClosedeposit}
              setOpen={setOpen}
              profileDetails={profileDetails}
              getListInfo={getListInfo}
            />
          )}
          <MenuItem
            value={30}
            sx={{ minHeight: matchessm ? '0px' : '' }}
            disabled={
              profileDetails?.PropertyDetails?.property?.status == 'Unpublish'
            }
            onClick={() => {
              hasVendorContract
                ? handleOpenView()
                : handleOpenFinalContractDialog();
              setActionDrawerOpen((prev) => !prev);
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '2px',
              }}
            >
              <SignContract />{' '}
              {hasVendorContract
                ? 'View Signed Contract'
                : 'Initiate Sign Request'}
            </Typography>
          </MenuItem>
          <Divider />
          {/* { && ( */}
          <MenuItem
            value={20}
            disabled={
              profileDetails?.PropertyDetails?.stage == 'ST2' ||
              !stagetwo ||
              isWinner == 1
            }
            // onClick={()=>{setForwardtobuyerbox(true);setOpen(false)}}>
            onClick={() => {
              setActionDrawerOpen((prev) => !prev);
              setOpenCommenceStageTwo(true);
              setOpen(false);
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <Timer /> Start Stage Timer 2
            </Typography>
            <Divider />
          </MenuItem>
          {/* )} */}
          <MenuItem
            value={20}
            sx={{ minHeight: matchessm ? '0px' : '' }}
            onClick={() => {
              setActionDrawerOpen((prev) => !prev);
              history.push('/helpcentre');
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginLeft: '-3px',
              }}
            >
              <NeedHelp /> Need Help
            </Typography>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setActionDrawerOpen((prev) => !prev);
            }}
            sx={{ minHeight: matchessm ? '0px' : '' }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginLeft: '-2px',
              }}
            >
              <CloseIcon />
              Cancel
            </Typography>
          </MenuItem>
        </>
      ) : (
        <>
          <MenuItem value={20}>
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 400,
                fontSize: '12px',
                color: '#8E8A8A',
                lineHeight: 'normal',
                fontStyle: 'normal',
              }}
            >
              - Offer Status Action -
            </Typography>
          </MenuItem>
          <MenuItem
            value={20}
            disabled={data?.offerUniqueId == undefined ? true : false}
            onClick={() => {
              discussAgent(data?.offerUniqueId);
              setActionDrawerOpen((prev) => !prev);
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              {/* status discuss */}
              <DiscusAgent /> Discuss with Agent
            </Typography>
          </MenuItem>
          <Divider />
          <MenuItem
            value={20}
            onClick={() => {
              manageOfferClick();
              setActionDrawerOpen((prev) => !prev);
            }}
            // disabled={!data?.price}
            disabled={
              !data?.price ||
              data?.status == 'Private Offer' ||
              data?.buyerId == 0
            }
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <Offer /> Manage Offer
            </Typography>
          </MenuItem>
          {(manageOffer || openhistorydialog) && (
            <ManageOffer
              open={manageOffer}
              vendorDatas={vendorDatas}
              onClose={manageOfferClickClose}
              buyerId={data?.buyerId}
              offerUniqueIds={data?.offerUniqueId}
              getListInfo={getListInfo}
              row={data}
              tableData={profileDetails}
              moxouserId={true}
              setManageOffer={setManageOffer}
              setOpenhistorydialog={setOpenhistorydialog}
              acceptLog={acceptLog}
              Glass={Glass}
              setVendorGeneratePdf={setVendorGeneratePdf}
            />
          )}
          <MenuItem
            value={20}
            disabled={true}
            onClick={() => {
              setActionDrawerOpen((prev) => !prev);
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <ViewAllOff /> View All Offers
            </Typography>
          </MenuItem>
          {/* <MenuItem value={20} disabled={data?.status == "Offer Received"|| props?.profileDetails?.PropertyDetails?.stage === "ST2" || !data?.price} 
                        onClick={()=>{setOpenWithdrawVendor(true); handleClosee()}}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Poppins!important",
                              fontWeight: 300,
                              fontSize: "14px",
                              color: "#FFFFFF",
                              fontStyle: "normal",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px"
                            }}
                          >
                            <WithdrawLastAct /> Withdraw Last Action
                          </Typography>
                        </MenuItem> */}
          <Divider />
          <MenuItem
            value={20}
            onClick={() => {
              setViewPrivateOffer(true);
              setActionDrawerOpen((prev) => !prev);
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <PrivateOffer /> View Private Offer
            </Typography>
          </MenuItem>
          <MenuItem
            value={30}
            disabled={!isEsignRequested && !hasVendorContract}
            onClick={() => {
              isEsignRequested ? handleCommenceESign() : handleOpenView();
              setActionDrawerOpen((prev) => !prev);
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <SignContract />{' '}
              {isEsignRequested ? 'Commence E-Sign' : 'View Signed Contract'}
            </Typography>
          </MenuItem>
          <Divider />
          <MenuItem
            value={20}
            onClick={() => {
              setActionDrawerOpen((prev) => !prev);
              history.push('/helpcentre');
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#FFFFFF',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <NeedHelp /> Need Help
            </Typography>
          </MenuItem>
        </>
      )}
    </SwipeableDrawer>
  );
};

export default VendorActionDrawer;
